// @flow

import React, {useState} from "react";
import {Tooltip} from "antd";

import {conditionalTooltipPropType} from "./ConditionalTooltipPropTypes";

export const ConditionalTooltip = ({condition, text, child, placement="topLeft"}: conditionalTooltipPropType) => {
    const [visible, setVisible] = useState(false);
    return (
        <Tooltip
            placement={placement}
            visible={visible}
            onVisibleChange={value => {
                if (value === true && condition) {
                    setVisible(true);
                } else {
                    setVisible(false);
                }
            }}
            title={text}
        >
            {child}
        </Tooltip>
    );
};
